import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStocks, deleteStock} from '../../redux/actions/stock/stockAction';
import DataTable from 'react-data-table-component';
import { Box, IconButton, TextField, Typography, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { confirmDelete, showSuccess } from '../../utils/alertUtils'; 
import { toast } from 'react-toastify';

const StockTable = ({ onEdit }) => {
  const dispatch = useDispatch();
  const stocks = useSelector((state) => state.stock.stocks);
  const { user } = useSelector((state) => state.login);
  const [filterText, setFilterText] = useState('');

  useEffect(() => {
    dispatch(fetchStocks());
  }, [dispatch]);

  const handleDelete = async (id) => {
      const result = await confirmDelete('Are you sure?', 'This stock will delete permanently!');
      if (result.isConfirmed) {
        try {
          await dispatch(deleteStock(id));
          showSuccess('Deleted!', 'The stock has been deleted.');
        } catch (error) {
          const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete stock';
          toast.error(errorMessage);
        }
      }
    };

  const handleNew = () => {
    onEdit(null); // This will reset the form and show it in "Add" mode
  };

  const filteredStocks = stocks.filter((stock) =>
    (stock.name || '').toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: <Typography fontWeight="bold">Stock Type</Typography>,
      selector: (row) => row.name,
      sortable: true,
    },
  
    ...(user?.role === 'Admin' ? [{
      name: <Typography fontWeight="bold">Actions</Typography>,
      cell: (row) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton size="small" onClick={() => onEdit(row)}>
            <EditIcon fontSize="small" sx={{ color: '#2196f3' }}/>
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.id)}>
            <DeleteIcon fontSize="small" sx={{ color: '#f44336' }}/>
          </IconButton>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }] : []),
  ];

  return (
   
  <Box>
    {/* Header Row with Title & Search */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Stock Types
        </Typography>
        {user?.role === 'Admin' && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleNew}
            size="small"
            sx={{ 
              backgroundColor: '#2196f3',
              '&:hover': {
                backgroundColor: '#1976d2',
              },
            }}
          >
            New
          </Button>
        )}
      </Box>

      <TextField
        size="small"
        placeholder="Search stock type..."
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
        sx={{
          width: '250px',
          '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
          },
        }}
      />
    </Box>

    {/* Table */}
    <Box sx={{ height: '400px', overflowY: 'auto' }}>
    <DataTable
      columns={columns}
      data={filteredStocks}
      pagination
      highlightOnHover
      dense
      responsive
      noHeader
    />
  </Box>
  </Box>
);
};

export default StockTable;
